import * as $runtime from "../runtime.js";
import * as App$dConditionLine from "../App.ConditionLine/index.js";
import * as App$dResult from "../App.Result/index.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as Control$dMonad$dMaybe$dTrans from "../Control.Monad.Maybe.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dCatList from "../Data.CatList/index.js";
import * as Data$dCatQueue from "../Data.CatQueue/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Halogen$dComponent from "../Halogen.Component/index.js";
import * as Halogen$dHTML from "../Halogen.HTML/index.js";
import * as Halogen$dHTML$dProperties from "../Halogen.HTML.Properties/index.js";
import * as Halogen$dQuery from "../Halogen.Query/index.js";
import * as Halogen$dQuery$dHalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen$dVDom$dTypes from "../Halogen.VDom.Types/index.js";
import * as TcgCalculator$dTypes from "../TcgCalculator.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Util$dHalogen from "../Util.Halogen/index.js";
const $Action = (tag, _1) => ({tag, _1});
const $Output = tag => tag;
const $Query = (tag, _1, _2) => ({tag, _1, _2});
const lineIsSymbol = {reflectSymbol: () => "line"};
const slot = /* #__PURE__ */ Halogen$dHTML.slot()(lineIsSymbol)(Data$dUUID.ordUUID);
const resultIsSymbol = {reflectSymbol: () => "result"};
const slot_ = /* #__PURE__ */ Halogen$dHTML.slot_()(resultIsSymbol)(Data$dOrd.ordUnit);
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Data$dMaybe.applicativeMaybe))();
const lookup = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = Data$dMaybe.Nothing;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordString.compare(k)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = Data$dMaybe.$Maybe("Just", v._4);
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const $$get = /* #__PURE__ */ Control$dMonad$dFree.$Free(
  /* #__PURE__ */ Control$dMonad$dFree.$FreeView(
    "Bind",
    /* #__PURE__ */ Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s, s)),
    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
  ),
  Data$dCatList.CatNil
);
const requestAll = /* #__PURE__ */ Halogen$dQuery.requestAll()(lineIsSymbol)(Data$dUUID.ordUUID);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Control$dMonad$dFree.freeApplicative)(Data$dFoldable.foldableArray);
const tell1 = /* #__PURE__ */ Halogen$dQuery.tell()(lineIsSymbol)(Data$dUUID.ordUUID);
const tell2 = /* #__PURE__ */ Halogen$dQuery.tell()(resultIsSymbol)(Data$dOrd.ordUnit);
const discard2 = /* #__PURE__ */ (() => Control$dMonad$dMaybe$dTrans.bindMaybeT(Control$dMonad$dFree.freeMonad).bind)();
const modify_ = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dMaybe$dTrans.monadStateMaybeT(Halogen$dQuery$dHalogenM.monadStateHalogenM);
  return f => $0.state(s => Data$dTuple.$Tuple(undefined, f(s)));
})();
const pure1 = /* #__PURE__ */ (() => Control$dMonad$dMaybe$dTrans.applicativeMaybeT(Control$dMonad$dFree.freeMonad).pure)();
const generateId = /* #__PURE__ */ (() => Halogen$dQuery$dHalogenM.monadEffectHalogenM(Effect$dAff.monadEffectAff).liftEffect(Data$dUUID.getUUIDImpl))();
const Updated = /* #__PURE__ */ $Output("Updated");
const AllConditionDeleted = /* #__PURE__ */ $Output("AllConditionDeleted");
const GetState = value0 => $Query("GetState", value0);
const UpdateState = value0 => value1 => $Query("UpdateState", value0, value1);
const ToggleDisabled = value0 => $Query("ToggleDisabled", value0);
const Initialize = /* #__PURE__ */ $Action("Initialize");
const AddCondition = /* #__PURE__ */ $Action("AddCondition");
const RemoveCondition = value0 => $Action("RemoveCondition", value0);
const ToggleItemDisabled = value0 => $Action("ToggleItemDisabled", value0);
const Receive = value0 => $Action("Receive", value0);
const ReceiveConditionUpdated = /* #__PURE__ */ $Action("ReceiveConditionUpdated");
const component = {
  initialState: v => ({conditions: [], deck: v, disabled: false}),
  render: v => Halogen$dVDom$dTypes.$VDom(
    "Elem",
    Data$dMaybe.Nothing,
    "div",
    [Halogen$dHTML$dProperties.classes(["grow rounded border-2 border-violet-300 p-1", v.disabled ? "bg-slate-100 text-gray-400" : "bg-white text-gray-700"])],
    [
      Halogen$dVDom$dTypes.$VDom(
        "Elem",
        Data$dMaybe.Nothing,
        "div",
        [Halogen$dHTML$dProperties.class_("flex items-center justify-end gap-1")],
        [
          Halogen$dVDom$dTypes.$VDom(
            "Elem",
            Data$dMaybe.Nothing,
            "div",
            [Halogen$dHTML$dProperties.class_(v.disabled ? "mr-auto w-0 py-1 pl-3 text-xl" : "hidden")],
            [Halogen$dVDom$dTypes.$VDom("Text", "Disabled")]
          ),
          Halogen$dVDom$dTypes.$VDom(
            "Elem",
            Data$dMaybe.Nothing,
            "div",
            [Halogen$dHTML$dProperties.class_(v.disabled ? "text-gray-400" : "text-black")],
            [slot_(Type$dProxy.Proxy)()(App$dResult.component)()]
          )
        ]
      ),
      Halogen$dVDom$dTypes.$VDom(
        "Elem",
        Data$dMaybe.Nothing,
        "ul",
        [Halogen$dHTML$dProperties.class_("my-1")],
        Data$dFunctor.arrayMap((() => {
          const $0 = v.deck.cards;
          return v$1 => Halogen$dVDom$dTypes.$VDom(
            "Elem",
            Data$dMaybe.Nothing,
            "li",
            [Halogen$dHTML$dProperties.classes(["flex gap-1 rounded px-1", v$1.disabled ? "bg-slate-100 text-gray-400 line-through" : "bg-transparent"])],
            [
              Halogen$dVDom$dTypes.$VDom(
                "Elem",
                Data$dMaybe.Nothing,
                "div",
                [Halogen$dHTML$dProperties.class_("mx-1 flex")],
                [
                  Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-xmark")], []))("text-gray-500 hover:bg-gray-200")($Action(
                    "RemoveCondition",
                    v$1.id
                  )),
                  Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-arrows-rotate")], []))("text-gray-500 hover:bg-gray-200")($Action(
                    "ToggleItemDisabled",
                    v$1.id
                  ))
                ]
              ),
              Halogen$dVDom$dTypes.$VDom(
                "Elem",
                Data$dMaybe.Nothing,
                "div",
                [Halogen$dHTML$dProperties.class_("min-w-0 grow")],
                [slot(Type$dProxy.Proxy)(v$1.id)(App$dConditionLine.component)($0)(v$2 => ReceiveConditionUpdated)]
              )
            ]
          );
        })())(v.conditions)
      ),
      Halogen$dVDom$dTypes.$VDom(
        "Elem",
        Data$dMaybe.Nothing,
        "div",
        [Halogen$dHTML$dProperties.class_("px-1")],
        [
          Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-plus")], []))("border border-sky-500 text-sky-700 hover:bg-sky-200")(AddCondition)
        ]
      )
    ]
  ),
  eval: /* #__PURE__ */ Halogen$dComponent.mkEval({
    ...Halogen$dComponent.defaultEval,
    handleAction: v => {
      if (v.tag === "Initialize") {
        return Control$dMonad$dFree.$Free(
          generateId._1,
          (() => {
            if (generateId._2.tag === "CatNil") {
              return Data$dCatList.$CatList(
                "CatCons",
                id => Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, conditions: [{id, disabled: false}]})),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                ),
                Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
              );
            }
            if (generateId._2.tag === "CatCons") {
              return Data$dCatList.$CatList(
                "CatCons",
                generateId._2._1,
                Data$dCatQueue.$CatQueue(
                  generateId._2._2._1,
                  Data$dList$dTypes.$List(
                    "Cons",
                    Data$dCatList.$CatList(
                      "CatCons",
                      id => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView(
                          "Bind",
                          Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, conditions: [{id, disabled: false}]})),
                          x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                        ),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    ),
                    generateId._2._2._2
                  )
                )
              );
            }
            $runtime.fail();
          })()
        );
      }
      if (v.tag === "AddCondition") {
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.conditions, s)),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList(
            "CatCons",
            conditions => {
              const $0 = id => Control$dMonad$dFree.$Free(
                Control$dMonad$dFree.$FreeView(
                  "Bind",
                  Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, conditions: Data$dArray.snoc(conditions)({id, disabled: false})})),
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                ),
                Data$dCatList.$CatList(
                  "CatCons",
                  () => Control$dMonad$dFree.$Free(
                    Control$dMonad$dFree.$FreeView(
                      "Bind",
                      Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                      x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                    ),
                    Data$dCatList.CatNil
                  ),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                )
              );
              return Control$dMonad$dFree.$Free(
                generateId._1,
                (() => {
                  if (generateId._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $0, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
                  if (generateId._2.tag === "CatCons") {
                    return Data$dCatList.$CatList(
                      "CatCons",
                      generateId._2._1,
                      Data$dCatQueue.$CatQueue(
                        generateId._2._2._1,
                        Data$dList$dTypes.$List(
                          "Cons",
                          Data$dCatList.$CatList("CatCons", $0, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)),
                          generateId._2._2._2
                        )
                      )
                    );
                  }
                  $runtime.fail();
                })()
              );
            },
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        );
      }
      if (v.tag === "RemoveCondition") {
        const $0 = v._1;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF(
              "State",
              s => {
                const s$p = {...s, conditions: Data$dArray.filterImpl(x => x.id !== $0, s.conditions)};
                return Data$dTuple.$Tuple(s$p, s$p);
              }
            ),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList(
            "CatCons",
            v1 => Control$dMonad$dFree.$Free(
              Control$dMonad$dFree.$FreeView(
                "Bind",
                Halogen$dQuery$dHalogenM.$HalogenF("Raise", v1.conditions.length === 0 ? AllConditionDeleted : Updated, undefined),
                x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
              ),
              Data$dCatList.CatNil
            ),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        );
      }
      if (v.tag === "ToggleItemDisabled") {
        const $0 = v._1;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF(
              "State",
              s => Data$dTuple.$Tuple(
                undefined,
                (() => {
                  const $1 = Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, x => x.id === $0, s.conditions);
                  if ($1.tag === "Just") {
                    const $2 = Data$dArray.modifyAt($1._1)(x => ({...x, disabled: !x.disabled}))(s.conditions);
                    if ($2.tag === "Just") { return {...s, conditions: $2._1}; }
                    if ($2.tag === "Nothing") { return s; }
                    $runtime.fail();
                  }
                  if ($1.tag === "Nothing") { return s; }
                  $runtime.fail();
                })()
              )
            ),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList(
            "CatCons",
            () => Control$dMonad$dFree.$Free(
              Control$dMonad$dFree.$FreeView(
                "Bind",
                Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
              ),
              Data$dCatList.CatNil
            ),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        );
      }
      if (v.tag === "Receive") {
        const $0 = v._1;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, deck: $0})),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.CatNil
        );
      }
      if (v.tag === "ReceiveConditionUpdated") {
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.CatNil
        );
      }
      $runtime.fail();
    },
    handleQuery: x => {
      if (x.tag === "GetState") {
        return Control$dMonad$dFree.freeApply.apply(Control$dMonad$dFree.$Free(
          $$get._1,
          Data$dCatList.$CatList(
            "CatCons",
            x$1 => Control$dMonad$dFree.$Free(
              Control$dMonad$dFree.$FreeView(
                "Return",
                (() => {
                  const $0 = x$1.conditions;
                  const $1 = x$1.disabled;
                  return v2 => {
                    const $2 = $0.length > 0
                      ? traverse(v3 => {
                          const $2 = lookup(v3.id)(v2);
                          if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", {id: v3.id, condition: $2._1, disabled: v3.disabled}); }
                          return Data$dMaybe.Nothing;
                        })($0)
                      : Data$dMaybe.Nothing;
                    if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", x._1({conditions: $2._1, disabled: $1})); }
                    return Data$dMaybe.Nothing;
                  };
                })()
              ),
              Data$dCatList.CatNil
            ),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        ))(requestAll(Type$dProxy.Proxy)(App$dConditionLine.GetCondition));
      }
      if (x.tag === "UpdateState") {
        const $0 = x._2;
        const $1 = x._1.conditions;
        const $2 = x._1.disabled;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF(
              "State",
              s => {
                const s$p = {...s, conditions: Data$dFunctor.arrayMap(v2 => ({id: v2.id, disabled: v2.disabled}))($1), disabled: $2};
                return Data$dTuple.$Tuple(s$p, s$p);
              }
            ),
            x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList(
            "CatCons",
            v1 => {
              const $3 = v1.deck;
              const $4 = for_($1)(v2 => tell1(Type$dProxy.Proxy)(v2.id)(App$dConditionLine.UpdateState(v2.condition)));
              const $5 = () => {
                const $5 = tell2(Type$dProxy.Proxy)()(App$dResult.Calculate($3)(Data$dArray.fromFoldableImpl(
                  Data$dFoldable.foldableMaybe.foldr,
                  TcgCalculator$dTypes.toConditionGroup($1)
                )));
                return Control$dMonad$dFree.$Free(
                  $5._1,
                  (() => {
                    if ($5._2.tag === "CatNil") {
                      return Data$dCatList.$CatList(
                        "CatCons",
                        () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      );
                    }
                    if ($5._2.tag === "CatCons") {
                      return Data$dCatList.$CatList(
                        "CatCons",
                        $5._2._1,
                        Data$dCatQueue.$CatQueue(
                          $5._2._2._1,
                          Data$dList$dTypes.$List(
                            "Cons",
                            Data$dCatList.$CatList(
                              "CatCons",
                              () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                            ),
                            $5._2._2._2
                          )
                        )
                      );
                    }
                    $runtime.fail();
                  })()
                );
              };
              return Control$dMonad$dFree.$Free(
                $4._1,
                (() => {
                  if ($4._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $5, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
                  if ($4._2.tag === "CatCons") {
                    return Data$dCatList.$CatList(
                      "CatCons",
                      $4._2._1,
                      Data$dCatQueue.$CatQueue(
                        $4._2._2._1,
                        Data$dList$dTypes.$List("Cons", Data$dCatList.$CatList("CatCons", $5, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)), $4._2._2._2)
                      )
                    );
                  }
                  $runtime.fail();
                })()
              );
            },
            Data$dCatQueue.$CatQueue(
              Data$dList$dTypes.Nil,
              Data$dList$dTypes.$List(
                "Cons",
                Data$dCatList.$CatList(
                  "CatCons",
                  a$p => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", Data$dMaybe.$Maybe("Just", a$p)), Data$dCatList.CatNil),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                ),
                Data$dList$dTypes.Nil
              )
            )
          )
        );
      }
      if (x.tag === "ToggleDisabled") {
        const $0 = x._1;
        return discard2(modify_(x$1 => ({...x$1, disabled: !x$1.disabled})))(() => pure1($0));
      }
      $runtime.fail();
    },
    receive: x => Data$dMaybe.$Maybe("Just", $Action("Receive", x)),
    initialize: /* #__PURE__ */ Data$dMaybe.$Maybe("Just", Initialize)
  })
};
export {
  $Action,
  $Output,
  $Query,
  AddCondition,
  AllConditionDeleted,
  GetState,
  Initialize,
  Receive,
  ReceiveConditionUpdated,
  RemoveCondition,
  ToggleDisabled,
  ToggleItemDisabled,
  UpdateState,
  Updated,
  component,
  discard2,
  for_,
  generateId,
  $$get as get,
  lineIsSymbol,
  lookup,
  modify_,
  pure1,
  requestAll,
  resultIsSymbol,
  slot,
  slot_,
  tell1,
  tell2,
  traverse
};
